var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.158,
    height: 28.175,
    viewBox: "0 0 28.158 28.175",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "lupa",
    transform: "translate(-318.87 -301.634)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "magnifying-glass-8-svgrepo-com",
    transform: "translate(318.87 301.634)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_7454",
    "data-name": "Trazado 7454",
    d: "M18.476,16.063a10.124,10.124,0,1,0-2.252,2.252l.783.782,2.252-2.252Zm-3-.748a7.349,7.349,0,1,1,0-10.393A7.35,7.35,0,0,1,15.476,15.316Z",
    transform: "translate(-0.159 0.001)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_7455",
    "data-name": "Trazado 7455",
    d: "M88.374,116.51A5.811,5.811,0,0,0,88,123.092a.408.408,0,0,0,.7-.426h0a5,5,0,0,1,.318-5.655.408.408,0,1,0-.644-.5Z",
    transform: "translate(-82.367 -109.95)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_7456",
    "data-name": "Trazado 7456",
    d: "M325.6,321.969l-7.6-6.791-2.64,2.64,6.791,7.6c.691.893,1.934.762,3.051-.355S326.5,322.66,325.6,321.969Z",
    transform: "translate(-298.015 -297.834)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.f9d19ae911f2620fcf3214ed445cef44.svg";
export { ForwardRef as ReactComponent };